export default "__VITE_ASSET__Cclv7O2T__"